import Button from 'react-bootstrap/Button'
import React from 'react'
import { CompanyHistoryModel } from '../../../../../models/CompanyHistoryModel'
import { ShowIf, DateField, TextField, validateFields, AbnField } from '../../../../../shared/fields'
import { ISection, TableColumn } from '../../../../../shared/table'
import { formatDateForDisplay, formatDigits } from '../../../../../shared/Utility'

export const companyHistoryColumns: TableColumn<CompanyHistoryModel>[] = [
  { name: 'Trading name', content: (d) => d.tradingName },
  { name: 'ABN', content: (d) => d.abn },
  { name: 'Date', content: (d) => formatDateForDisplay(d.establishedOn) },
]

export interface CompanyHistoryDetailsProps {
    id: string
    model: CompanyHistoryModel
    onChange: { (v: CompanyHistoryModel, close: boolean): any }
    onClose: { (): any }
    onRemove: { (): any }
    importing: boolean
    preview?: boolean
}

export interface CompanyHistoryDetailsState {
    model: CompanyHistoryModel
}

export class CompanyHistoryDetails extends React.Component<CompanyHistoryDetailsProps, CompanyHistoryDetailsState> implements ISection {
  registeredName: TextField
  tradingName: TextField
  abn: TextField
  establishedOn: DateField

  constructor(props: CompanyHistoryDetailsProps) {
    super(props)

    let model: CompanyHistoryModel = this.props.model ? { ...this.props.model } : {
      applicationID: '',
      companyHistoryID: 0,
      tradingName: '',
      rowState: 1,
      abn: '',
      establishedOn: '',
      invalid: false
    }

    this.state = {
      model
    }
  }

  validate = (callback: { (res: boolean): any }) => {
    validateFields((res) => callback(res),
      this.registeredName,
      this.tradingName,
      this.abn,
      this.establishedOn,
    )
  }

  saveAndClose = (callback?: { (res: boolean): any }) => {
    this.validate((res) => {
      if (res) {
        this.props.onChange(this.state.model, true)
      }
      callback && callback(res)
    })
  }

  componentDidMount() {
    if (this.props.importing) {
      this.validate((res) => {
        var temp = { invalid: !res }
        this.props.onChange({ ...this.state.model, ...temp }, true)
      })
    } else if (this.state.model.invalid) {
      this.validate(() => { })
    }
  }

  onChange = (change: Partial<CompanyHistoryModel>, callback?: { (): any }) => {
    this.setState({
      model: { ...this.state.model, ...change },
    }, callback)
  }

  render() {
    const { model } = this.state

    return <>
      <TextField ref={(r) => this.tradingName = r}
        id={`${this.props.id}-tradingName`}
        label="Trading name"
        value={model.tradingName}
        onChange={(tradingName) => this.onChange({ tradingName })}
        required
        maxLength={80}
      />

      <AbnField
        ref={(r) => { this.abn = r }}
        id={`${this.props.id}-abn`}
        label="ABN"
        value={formatDigits(model.abn)}
        onChange={(abn) => this.onChange({ abn: abn.replace(/ /g,'') })}
        required
        block={false}
        maxLength={14}
      />

      <DateField ref={(r) => this.establishedOn = r}
        id={`${this.props.id}-establishedOn`}
        label="Date"
        value={model.establishedOn}
        onChange={(establishedOn) => this.onChange({ establishedOn })}
        required
        max={new Date()} // today or earlier
      />

      <ShowIf condition={!this.props.preview} className="clearfix mt-3">
        <Button className="emdg-btn float-right" onClick={(e) => this.saveAndClose()}>Complete row</Button>
        <Button className="emdg-btn emdg-btn--secondary float-left mr-2" onClick={this.props.onClose} >Cancel</Button>
        <Button className="emdg-btn emdg-btn--secondary float-left" onClick={this.props.onRemove} style={{ display: this.props.model ? '' : 'none' }}>Remove</Button>
      </ShowIf>
    </>
  }
}
